import { ComponentProps } from 'react';
import { GlobalHeader } from 'br2s-ui-componentlibrary_r2_02';
import { LocalStorageService } from 'br2s-ui-common-utils-02';
import { AUTH_SCOPES } from '@/utilities/authScopes';
import { RootState } from '@/redux/store';
import { checkIndicator, renderButtons } from '@/utilities/utilities';
import { ROLES, SPCP_ORIGIN } from '@/utilities/constants';

type DropdownButtonsType = ComponentProps<
  typeof GlobalHeader
>['dropdownButtons'];

type HeaderKey =
  | 'TRANSACTIONS'
  | 'CORPORATE_SERVICE_PROVIDER'
  | 'MY_CLIENTS'
  | 'PAYMENT_HISTORY';

type ProfileIndicatorType = {
  roles?: any;
  origin?: string;
};

export const getHeaderDropdownButtons = ({
  hasProfileAccess,
  hasCspProfile,
}: RootState['auth']): DropdownButtonsType => {
  const { scopes, origin, cspIndicator } = LocalStorageService.getAuthInfo(
    'scopes',
    'origin',
    'cspIndicator',
  );

  const headerDropdownButtons = [
    'DASHBOARD',
    'PAYMENT_SETTINGS',
    'INBOX',
  ] as DropdownButtonsType;

  if (origin === 'CP') headerDropdownButtons?.push('ENTITIES');

  if (scopes?.includes(AUTH_SCOPES.SWITCHPROFILE_READ))
    headerDropdownButtons?.push('SWITCH_PROFILE');

  if (hasProfileAccess) headerDropdownButtons?.push('MY_PROFILE');

  renderButtons(origin ?? '', cspIndicator ?? '', hasCspProfile).forEach(
    ({ headerKey }) => headerDropdownButtons?.push(headerKey as HeaderKey),
  );

  return headerDropdownButtons;
};

export const showProfileIndicator = ({
  roles,
  origin,
}: ProfileIndicatorType): boolean => {
  const isOnlyCorpPass =
    roles.length === 1 && roles.includes(ROLES.CORPPASS_AUTHENTICATED);

  if (
    origin === SPCP_ORIGIN.SP || // Singpass login
    (!checkIndicator() && isOnlyCorpPass) || // all the indicators are "N", roles have nothing else other than "CorpPass Authenticated"
    roles.includes(ROLES.GOVT_AGENCY) // Goverment agency
  ) {
    return false;
  }

  return true;
};
